import { Icon } from '@chakra-ui/react';

export default function SFLockIcon(props) {
  return (
    <Icon
      width={25}
      height={24}
      viewBox='0 0 25 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M8.922 19.82c-1.149 0-1.758-.625-1.758-1.86v-5.382c0-1.086.477-1.695 1.367-1.828V8.86c0-2.938 1.922-4.368 3.961-4.368 2.047 0 3.969 1.43 3.969 4.367v1.891c.898.133 1.367.742 1.367 1.828v5.383c0 1.234-.61 1.86-1.758 1.86zm.851-11.132v2.039h5.454v-2.04c0-1.968-1.274-3.015-2.735-3.015S9.773 6.719 9.773 8.688' />
    </Icon>
  );
}
